module.exports = __webpack_public_path__ + "img/hr-V-L-2-unload-standup-shadow.abe4ec63.png";